import React, { useCallback, useState } from 'react'
const noop = () => {}

/**
 *
 * @type {React.Context<{isMfeLoaded: (function(mfeKey: string): boolean), loadMfe: (function(mfeKey: string): Promise<*>)}>}
 */
export const MfeLoaderContext = React.createContext({
    loadMfe: noop,
    isMfeLoaded: noop,
})

export default function MfeLoader({ children }) {
    const [mfeMap, setMfeMap] = useState(new Map())
    const isMfeLoaded = useCallback(mfeKey => mfeMap.has(mfeKey), [mfeMap])
    const loadMfe = useCallback(
        async function _loadMfe(mfeKey) {
            if (isMfeLoaded(mfeKey)) {
                return mfeMap.get(mfeKey)
            }
            return import(
                /* webpackIgnore: true */
                mfeKey
            ).then(module => {
                setMfeMap(new Map([...mfeMap.entries(), [mfeKey, module]]))
                return module
            })
        },
        [isMfeLoaded, mfeMap]
    )

    return (
        <MfeLoaderContext.Provider
            value={{
                loadMfe,
                isMfeLoaded,
            }}
        >
            {children}
        </MfeLoaderContext.Provider>
    )
}
